import { render, staticRenderFns } from "./LeftCertificacoes.vue?vue&type=template&id=99d1d80e&scoped=true"
import script from "./LeftCertificacoes.vue?vue&type=script&lang=js"
export * from "./LeftCertificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d1d80e",
  null
  
)

export default component.exports